import { useEffect, useState } from "react";
import { getNewDesignRequest, getSteps } from "./stores/wizard";
import QuickViewWizard from "./components/QuickView";
import Loading from "./components/commons/Loading";
import "./App.css";
import NavBar from "./components/commons/NavBar";

function App() {
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const authToken = urlParams.get("customerToken");
    const customerId = urlParams.get("customerId");

    if (authToken) {
      localStorage.setItem("customerToken", authToken);
    }

    if (customerId) {
      localStorage.setItem("customerId", customerId);
    }

    const fetchData = async () => {
      const storedToken = localStorage.getItem("customerToken");

      if (!storedToken) {
        console.error("No auth token found!");
        return;
      }

      try {
        setLoading(true);
        await getNewDesignRequest();
        await getSteps({ updateSteps: true });
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="app-container w-full mb-8">
      <NavBar></NavBar>
      <QuickViewWizard />
    </div>
  );
}

export default App;
